export default class FollowingModel {
    public avatar: string = null;
    public followingId: string = null;
    public name: string = null;
    public nickname: string = null;
    public profileId: string = null;
}